import { getFirebase } from 'firestorter';

import Collections from '../../utils/collections';
import { ContactProvider } from '../Model/Lead';
import { IG_MSG_STATUS } from '../Model/LeadMsg';

/**
 * Queue an outgoing IG DM by writing a 'queued' leadMsgs doc and updating
 * the leadConversations preview fields. The system2-instagram-agent picks
 * up docs where provider=='Instagram' and igMsgStatus=='queued'.
 *
 * @param {Object} params
 * @param {string} params.leadId
 * @param {string} params.coachId
 * @param {string} params.igHandle - lead's Instagram handle
 * @param {string} params.body - message text
 * @param {string} params.userId - sender's user ID
 * @param {string} params.userName - sender's display name
 */
const sendIGDM = async ({
  leadId, coachId, igHandle, body, userId, userName, leadName,
}) => {
  const db = getFirebase().default.firestore();

  await db.collection(Collections.LEAD_MSGS).add({
    provider: ContactProvider.INSTAGRAM,
    igMsgStatus: IG_MSG_STATUS.QUEUED,
    isFromMe: true,
    body,
    leadId,
    coachId,
    igHandle,
    sentAt: new Date(),
    sentAs: userId,
    sentAsUsername: userName,
    from: 'Coach',
    to: igHandle,
  });

  await db.collection(Collections.LEAD_CONVERSATION).doc(leadId).set(
    {
      leadId,
      leadName: leadName || '',
      lastIgMessageAt: new Date(),
      lastIgMessageText: body,
      igIsArchived: true,
    },
    { merge: true },
  );
};

export { sendIGDM };
